import type { CalendarMutationRequest } from '@/types/calendarModule';

export const CALENDAR_MODULE_LIST_REQUEST = 'CALENDAR_MODULE_LIST_REQUEST';
export const CALENDAR_MODULE_LIST_SUCCESS = 'CALENDAR_MODULE_LIST_SUCCESS';
export const CALENDAR_MODULE_LIST_FAILURE = 'CALENDAR_MODULE_LIST_FAILURE';
export const CALENDAR_EVENT_LIST_REQUEST = 'CALENDAR_EVENT_LIST_REQUEST';
export const CALENDAR_EVENT_LIST_SUCCESS = 'CALENDAR_EVENT_LIST_SUCCESS';
export const CALENDAR_EVENT_LIST_FAILURE = 'CALENDAR_EVENT_LIST_FAILURE';
export const CALENDAR_SOURCE_LIST_REQUEST = 'CALENDAR_SOURCE_LIST_REQUEST';
export const CALENDAR_SOURCE_LIST_SUCCESS = 'CALENDAR_SOURCE_LIST_SUCCESS';
export const CALENDAR_SOURCE_LIST_FAILURE = 'CALENDAR_SOURCE_LIST_FAILURE';
export const CALENDAR_LOOKUP_REQUEST = 'CALENDAR_LOOKUP_REQUEST';
export const CALENDAR_LOOKUP_SUCCESS = 'CALENDAR_LOOKUP_SUCCESS';
export const CALENDAR_LOOKUP_FAILURE = 'CALENDAR_LOOKUP_FAILURE';
export const CALENDAR_MUTATION_REQUEST = 'CALENDAR_MUTATION_REQUEST';
export const CALENDAR_MUTATION_SUCCESS = 'CALENDAR_MUTATION_SUCCESS';
export const CALENDAR_MUTATION_FAILURE = 'CALENDAR_MUTATION_FAILURE';
export const CALENDAR_MODULE_PROCESS_RESET = 'CALENDAR_MODULE_PROCESS_RESET';
export const CALENDAR_MODULE_UNAVAILABLE = 'CALENDAR_MODULE_UNAVAILABLE';

export interface CalendarModuleListRequest {
  type: typeof CALENDAR_MODULE_LIST_REQUEST;
  payload: { calendar_type?: string };
}

export interface CalendarEventListRequest {
  type: typeof CALENDAR_EVENT_LIST_REQUEST;
  payload: Record<string, unknown>;
}

export interface CalendarSourceListRequest {
  type: typeof CALENDAR_SOURCE_LIST_REQUEST;
  payload: { calendar_id: number };
}

export interface CalendarLookupRequest {
  type: typeof CALENDAR_LOOKUP_REQUEST;
  payload: { start_date: string; end_date: string; calendar_type?: string };
}

export interface CalendarMutationRequestAction {
  type: typeof CALENDAR_MUTATION_REQUEST;
  payload: CalendarMutationRequest;
}

export type CalendarModuleRequestAction =
  | CalendarModuleListRequest
  | CalendarEventListRequest
  | CalendarSourceListRequest
  | CalendarLookupRequest
  | CalendarMutationRequestAction;
